import type { BaseResponse } from "@marketplace/shared/types";
import { notifications } from "@marketplace/ui/notifications";
import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import type { SetupAutomationNotifyRequestDto } from "../../dtos/setup-automation-notify-request-dto";
import { AutomationQueryKeys } from "../../generators/automation-query-keys";
import { AutomationService } from "../../services/automation-service";

type UseSetupAutomationNotifyMutationParams = {
  options?: UseMutationOptions<
    BaseResponse<undefined>,
    unknown,
    { payload: SetupAutomationNotifyRequestDto }
  >;
};

export const useSetupAutomationNotifyMutation = ({
  options
}: UseSetupAutomationNotifyMutationParams = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("product", {
    keyPrefix: "automation.notify"
  });

  return useMutation({
    mutationFn: AutomationService.setupAutomationNotify,
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: AutomationQueryKeys.getAutomationList._def
      });
      notifications.show({
        message: t("successMessage")
      });
      options?.onSuccess?.(...args);
    },
    onError: (...errorArgs) => {
      notifications.show({
        message: t("errorMessage"),
        variant: "error"
      });
      options?.onError?.(...errorArgs);
    }
  });
};
